export default "/_next/static/src/lib/assets/rive/92af464584d363c23691c91ba316fa7e.riv";